import React, { useState } from "react";
import axios from "axios";
import { IconButton, Tooltip, CircularProgress } from "@mui/material";
import { Terrain } from "@mui/icons-material";
import { useAuth0 } from "@auth0/auth0-react";
import { useApp } from "../AppProvider";

export default function FetchElevationButton({ lat, lon, onSuccess }) {
  const { getAccessTokenSilently } = useAuth0();
  const { doToast } = useApp();
  const [loading, setLoading] = useState(false);

  const isAvailable = typeof lat === "number" && typeof lon === "number";

  const handleClick = async () => {
    if (!isAvailable || loading) return;
    setLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/water-level-records/elevation`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { lat, lon },
        }
      );
      const elevation = data?.elevation ?? null;
      if (elevation != null) {
        onSuccess?.(Math.round(elevation * 100) / 100);
      } else {
        doToast("error", "No elevation data returned from the API.");
      }
    } catch (error) {
      console.error("Failed to fetch elevation", error);
      doToast("error", "Failed to fetch elevation. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip
      title={
        isAvailable
          ? "Fetch elevation from USGS National Map API"
          : "Coordinates unavailable"
      }
    >
      <span>
        <IconButton
          edge="end"
          size="small"
          color="secondary"
          onClick={handleClick}
          disabled={!isAvailable || loading}
          sx={{
            border: "1px solid",
            borderColor: (theme) =>
              loading ? "transparent" : theme.palette.primary.main,
            borderRadius: 1,
            padding: "4px",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: (theme) => theme.palette.action.hover,
            },
          }}
        >
          {loading ? <CircularProgress size={20} /> : <Terrain />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
